import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import Card from './Card'
import { useRussianPokerStore } from './useRussianPokerStore'

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const CardsContainer = styled.div`
  gap: 10px;
  max-height: 140px;
  display: flex;
  justify-content: center;
`

const CardItem = styled.div`
  width: 90px;
  height: 140px;
  display: flex;
  justify-self: center;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.29);
  box-shadow: 0 75px 189px 0 rgba(255, 255, 255, 0.12) inset;
  backdrop-filter: blur(3px);
`

const DealerCards = observer(() => {
  const { session } = useRussianPokerStore()
  if (!session) return null
  const { cards } = session

  const card1 = cards[0]
  const card2 = cards[1]
  const card3 = cards[2]
  const card4 = cards[3]
  const card5 = cards[4]

  return (
    <Container>
      <CardsContainer>
        <CardItem>{card1 && <Card value={card1} />}</CardItem>
        <CardItem>{card2 && <Card value={card2} />}</CardItem>
        <CardItem>{card3 && <Card value={card3} />}</CardItem>
        <CardItem>{card4 && <Card value={card4} />}</CardItem>
        <CardItem>{card5 && <Card value={card5} />}</CardItem>
      </CardsContainer>
    </Container>
  )
})

export default DealerCards
